import { cleanObject } from '@shared/utils/helpers/clean-object';

const VIRTUAL_FIELDS = { isNew: 'isNew' };
const DIVISION_DATASET = {
  ...VIRTUAL_FIELDS,
  division_id: 'division_id',
  division_desc: 'division_desc',
  global_region_id: 'global_region_id',
  global_region_desc: 'global_region_desc',
  market_id: 'market_id',
  market_desc: 'market_desc',
  submarket_id: 'submarket_id',
  submarket_desc: 'submarket_desc',
  district_id: 'district_id',
  district_desc: 'district_desc',
  neighborhood_id: 'neighborhood_id',
  neighborhood_desc: 'neighborhood_desc',
};

/**
 * Tim Division composer
 */
export const Division = state => {
  state =
    !!state && !!Object.keys(state).length && !!state.lig_geography
      ? { ...state, lig_geography: state.lig_geography.map(DIVISION_DATASET) }
      : state;
  return Object.assign({}, cleanObject(state, true));
};

/**
 * Tim New Geos Target Location property
 * @param ligGeography tim target_geography
 */
export const GeoTargetLocation = state => {
  const ligGeography =
    !!state && !!state.lig_geography && Array.isArray(state.lig_geography)
      ? { lig_geography: state.lig_geography.map(Division) }
      : {};
  return Object.assign({}, state, ligGeography);
};
